import { Button, Modal } from '@design-systems/canvas-ui'

// Asked before uploading files whose names this brand already has.
const DuplicateUploadModal = ({
  duplicateNames = [],
  fileCount = 0,
  isOpen,
  onClose,
  onConfirm,
}) => {
  const footer = (
    <div className="publish-queue-modal__actions">
      <Button onClick={onClose} variant="secondary">
        Cancel
      </Button>
      <Button onClick={onConfirm} variant="primary">
        Upload anyway
      </Button>
    </div>
  )

  return (
    <Modal
      footer={footer}
      headingText="Some documents already exist"
      isOpen={isOpen}
      onClose={onClose}
      size="sm"
    >
      <p>
        {duplicateNames.length} out of {fileCount} documents already exist for
        this brand:
      </p>
      <ul className="duplicate-upload-modal__list">
        {duplicateNames.map((name) => (
          <li key={name}>{name}</li>
        ))}
      </ul>
      <p>Upload them again anyway?</p>
    </Modal>
  )
}

export default DuplicateUploadModal
